export const LYRICS = [
  [10, "Je suis venue sans rendez-vous"],
  [15, "Un peu d'ailleurs, un peu de vous"],
  [20, "Regardez tourner votre Terre"],
  [24, "Vos petits mondes"],
  [26, "Vos frontières"],
  [29, "Je n'ai ni patience ni leçon"],
  [32, "Je n'ai qu'une interrogation"],
  [34, "Et plus je cherche une réponse"],
  [39, "Plus une autre question s'annonce"],
  [42, "Pose la question", true],
  [45, "Pose-la bien", true],
  [48, "La réponse est peut-être en chemin", true],
  [51, "Avant de parler"],
  [54, "Avant de savoir"],
  [57, "Commence peut-être par vouloir voir"],
  [61, "La grande question", true],
  [63, "Encore et toujours", true],
  [67, "De la première nuit"],
  [69, "Au dernier jour"],
  [71, "Pourquoi ? Comment ? Pour qui ? Jusqu'où ?", true],
  [76, "Et après tout, qu'en faites-vous ?"],
  [92, "Naître, paraître, être un instant"],
  [97, "Croire qu'on possède encore le temps"],
  [100, "Aimer, construire, rire et souffrir"],
  [105, "Finalement"],
  [107, "De voir partir"],
  [111, "Entre l'entrée et la sortie"],
  [116, "Entre la braise et puis la pluie"],
  [121, "S'il reste encore un peu de temps"],
  [125, "Posons la question simplement"],
  [129, "Pose la question", true],
  [131, "Pose-la bien", true],
  [134, "La réponse est peut-être en chemin", true],
  [139, "La vérité"],
  [141, "N'est à personne"],
  [143, "Elle change parfois"],
  [145, "Quand la question résonne"],
  [158, "Je ne veux pas avoir raison", true],
  [162, "Je veux comprendre la question", true],
  [167, "Et si je me trompe"],
  [169, "Dites-moi pourquoi"],
  [173, "Je recommencerai"],
  [176, "Une autre fois"],
];
